import styled, { css } from "styled-components";

export const Form = styled.form`
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  z-index: 5;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 5}px;

  @media (min-width: 1025px) {
    width: 30%;
    gap: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  }
`;

export const FormTitle = styled.h2`
  font-family: "Sora", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
  color: ${({ theme }) => theme.THEME.white};
  font-weight: 600;
  text-align: center;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
    text-align: left;
  }
`;

export const Tabs = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 1.5}px;

  @media (min-width: 1025px) {
    gap: 2rem;
    margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  }
`;

export const Tab = styled.button<{ $active?: boolean }>`
  font-family: "Sora", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 25}px;
  color: ${({ theme, $active }) =>
    $active ? theme.THEME.white : theme.THEME.grayText};
  border: none;
  background: none;
  font-weight: ${({ $active }) => ($active ? "600" : "400")};
  border-bottom: ${({ $active, theme }) =>
    $active ? `2px solid ${theme.THEME.white}` : "none"};
  cursor: pointer;
  padding: 4px 0;
  transition: color 0.3s, transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 9}px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 23}px;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 0.5}px;
  font-family: "Sora", sans-serif;

  span {
    color: ${({ theme }) => theme.THEME.neonBlue};
    margin-left: 4px;
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 5.8}px;
  }
`;

export const FieldWrapper = styled.div<{
  $focused: boolean;
  $hasError: boolean;
}>`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 12px 16px;
  transition: 0.3s ease;
  backdrop-filter: blur(6px);
  position: relative;

  ${({ $hasError, theme }) =>
    $hasError &&
    css`
      border-color: ${theme.THEME.error};
      box-shadow: 0 0 10px ${theme.THEME.error};
    `}

  ${({ $focused, $hasError, theme }) =>
    $focused &&
    !$hasError &&
    css`
      border-color: ${theme.THEME.neonBlue};
      box-shadow: 0 0 12px ${theme.THEME.neonBlue};
    `}
`;

export const InputWrapper = styled.div<{ $hasError?: boolean }>`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 12px 16px;
  transition: 0.3s ease;
  backdrop-filter: blur(6px);
  position: relative;

  ${({ $hasError, theme }) =>
    $hasError &&
    css`
      border-color: ${theme.THEME.error};
      box-shadow: 0 0 10px ${theme.THEME.error};
    `}

  &:focus-within {
    ${({ $hasError, theme }) =>
      $hasError
        ? css`
            border-color: ${theme.THEME.error};
            box-shadow: 0 0 8px ${theme.THEME.error};
          `
        : css`
            border-color: ${theme.THEME.neonBlue};
            box-shadow: 0 0 10px ${theme.THEME.neonBlue};
          `}
  }
`;

export const Icon = styled.div`
  margin-right: 12px;
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
  }
`;

export const Message = styled.p`
  color: ${({ theme }) => theme.THEME.error};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 20}px;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 0.5}px;
  font-family: "Inter", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 5}px;
  }
`;
